import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'
import { env } from 'src/configs/env'
import { RewardsPoints } from 'src/types/RewardsPoints'
import {
  ContextoGlobalInitialValue,
  PaymentMethod,
  SacDadosAtendimento,
} from './types'
import {
  BannerHeaderResponse,
  MenuCategoriesResponse,
  MenuDoubtsResponse,
  MenuHeaderResponse,
  MenuIntitutionalResponse,
  MenusResponse,
} from 'src/services/marketplace-api'
import { useRouter } from 'next/router'
import { OriginLoadingEnum } from 'src/util/enums/origin-loading'

type Props = {
  start: () => void
  end: () => void
  children: ReactNode
  isBlackFridayTheme: boolean
  nonce?: string
  paymentMethods: PaymentMethod[]
  menusData: MenusResponse
  bannerHeaderData: BannerHeaderResponse
  sacInformation: SacDadosAtendimento
}

export const initialValue: ContextoGlobalInitialValue = {
  start: () => undefined,
  end: () => undefined,
  originLoading: undefined,
  setOriginLoading: () => undefined,
  paymentMethodStore: [],
  zipcode: undefined,
  setZipcode: () => undefined,
  isBlackFridayTheme: false,
  reward: {
    slug: '',
    points: 0,
    value: 0,
  },
  setReward: () => 0,
  nonceValue: undefined,
  menuInstitucionalData: {} as MenuIntitutionalResponse,
  menuCategoriasData: {} as MenuCategoriesResponse,
  menuDuvidasData: {} as MenuDoubtsResponse,
  menuHeaderData: {} as MenuHeaderResponse,
  bannerHeaderData: {} as BannerHeaderResponse,
  sacInformation: {} as SacDadosAtendimento,
}

export const ContextoGlobal = createContext(initialValue)

export const useGlobalContext = () => useContext(ContextoGlobal)

const ContextoGlobalProvider: React.FC<Props> = ({
  start,
  end,
  children,
  nonce,
  paymentMethods,
  menusData,
  bannerHeaderData,
  sacInformation,
}) => {
  const [zipcode, setZipcode] = useState<string | undefined>()
  const [reward, setReward] = useState<RewardsPoints>({
    slug: '',
    points: 0,
    value: 0,
  })
  const [originLoading, setOriginLoading] = useState<
    OriginLoadingEnum | undefined
  >()

  const router = useRouter()

  useEffect(() => {
    setOriginLoading(undefined)
  }, [router])

  const [nonceValue] = useState<string | undefined>(nonce)

  const isBlackFridayTheme = env.isDarkTheme

  return (
    <ContextoGlobal.Provider
      value={{
        start,
        end,
        originLoading,
        setOriginLoading,
        paymentMethodStore: paymentMethods,
        zipcode,
        setZipcode,
        isBlackFridayTheme,
        reward,
        setReward,
        nonceValue,
        menuInstitucionalData: menusData['menu-rodape-institucional'],
        menuCategoriasData: menusData['menu-topo-categorias'],
        menuDuvidasData: menusData['menu-rodape-duvidas'],
        menuHeaderData: menusData['menu-topo-categoria-principal'],
        bannerHeaderData,
        sacInformation,
      }}
    >
      {children}
    </ContextoGlobal.Provider>
  )
}

export default ContextoGlobalProvider
